module.exports = __webpack_public_path__ + "img/index_banner5.bc9eac0f.png";